import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from "react-router-dom";
import Modal from "../../components/parent/Modal"
import API_ENDPOINTS from '../../utils/apiEndpoints';

const AcademicInfo = () => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const { id } = useParams();

  const navigate = useNavigate();
  const fileInputPhotoRef = useRef(null);
  const fileInputDocumentsRef = useRef(null);

  const [classes, setClasses] = useState([]);
  const [casteCategory, setCasteCategory] = useState([]);
  const [languages, setlanguages] = useState([]);
  const [genders, setgenders] = useState([]);
  const [extra_curricular_activities, setextra_curricular_activities] = useState([]);
  const [countries, setcountries] = useState([]);
  const [co_curricular_activities, setco_curricular_activities] = useState([]);
  const [blood_groups, setblood_groups] = useState([]);
  const [boards, setboards] = useState([]);

  const [mediums, setmediums] = useState([]);
  const [board, setboard] = useState([])
  const [language, setlanguage] = useState([])
  const [extraCurricular, setextraCurricular] = useState([])





  const [checkboxes, setCheckboxes] = useState({
    termsChecked: false,
    privacyChecked: false
  });
  const [formData, setFormData] = useState({
    medium_id: '',
    prevSchoolName: '',
    prevSchoolAddress: '',
    prevSchoolPincode: '',
    board_id: '',
    lastAnnualExamMarks: {
      marksofClass: '',
      English: '',
      Kannada: '',
      language_id: '',
      LanguageMarks: '',
      Maths: '',
      Science: '',
      Social: '',
      Total: '',
      PercentageCGPA: '',
    },
    candidateAdhaarNo: '',
    candidateSATSNo: '',
    candidatePENNo: '',
    class_id: '',
    siblingsinSSV: '',
    SiblingsData: '',
    beenToSSBV: '',
    co_curricular_activity_id: '',
    candidateAim: '',
    extra_curricular_activity_id: [],
    achivements: '',

  });

  if (formData.siblingsinSSV === "no" || "") {
    formData.SiblingsData = ""
  }

  //     const downloadJSON = () => {
  //   const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(formData, null, 2));
  //   const anchor = document.createElement("a");
  //   anchor.href = dataStr;
  //   anchor.download = "data.json";
  //   document.body.appendChild(anchor);
  //   anchor.click();
  //   document.body.removeChild(anchor);
  // };



  const updatedPreviewData =
  {
    "Medium of Instruction in the Class Studied": mediums.find(cls => cls.id === Number(formData.medium_id))?.media,
    "Previous School Name": formData.prevSchoolName,
    "Previous School Address": formData.prevSchoolAddress,
    "Previous School Pincode": formData.prevSchoolPincode,
    "Previous School Board": board.find(cls => cls.id === Number(formData.board_id))?.board_name,
    "Below Marks of the Class": formData.lastAnnualExamMarks.marksofClass,
    "English Marks": formData.lastAnnualExamMarks.English,
    "Kannada Marks": formData.lastAnnualExamMarks.Kannada,
    // "Language Marks": formData.lastAnnualExamMarks.Language,
    [`${language.find(cls => cls.id === Number(formData.lastAnnualExamMarks.language_id))?.language} Marks`]: formData.lastAnnualExamMarks.LanguageMarks,
    "Maths Marks": formData.lastAnnualExamMarks.Maths,
    "Science Marks": formData.lastAnnualExamMarks.Science,
    "Social Marks": formData.lastAnnualExamMarks.Social,
    "Total Marks": formData.lastAnnualExamMarks.Total,
    "Percentage/CGPA": formData.lastAnnualExamMarks.PercentageCGPA,
    "Extra-Curricular Activities": formData.extra_curricular_activity_id
      .map(id => extraCurricular.find(cls => cls.id === id)?.activity_name) // Map IDs to names
      .filter(Boolean).join(', '),  // If array, join them into a string
    "Achievements": formData.achivements,
    "Candidate SATS Number": formData.candidateSATSNo,
    "Class for which Admission is Sought": classes.find(cls => cls.id === Number(formData.class_id))?.name || 'Class not found',
    "Siblings in SSV": formData.siblingsinSSV,
    "Siblings Information": formData.SiblingsData,
    "Been a student of Sathya Sai Bal Vikas": formData.beenToSSBV,
    "Co-Curricular Activity Wish to Join": co_curricular_activities.find(cls => cls.id === Number(formData.co_curricular_activity_id))?.activity_name,
    "Aim and Objective": formData.candidateAim
  }


  useEffect(() => {
    const token = localStorage.getItem("parentToken");

    if (!token) {
      console.error("No token found in localStorage");
      return;
    }

    fetch(API_ENDPOINTS.DROPDOWN_DATA, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    })
      .then(response => response.json())
      .then(data => {
        setClasses(data.data.classes);
        setmediums(data.data.mediums)
        setlanguage(data.data.languages)
        setboard(data.data.boards)
        setextraCurricular(data.data.extra_curricular_activities)
        setco_curricular_activities(data.data.co_curricular_activities)

      })
      .catch(error => console.error("Error fetching classes:", error));
  }, []);

  // useEffect(() => {
  //     // Include the Bearer token in the GET request
  //     axios.get('http://127.0.0.1:8000/api/classes', {
  //         headers: { Authorization: `Bearer ${localStorage.getItem('parentToken')}` }
  //     })

  //         .then(response => setClasses(response.data))
  //         .catch(error => console.error('Error fetching classes:', error));
  // }, []);

  const handleChange = (e) => {
    const value = e.target.value.replace(/[^\x00-\x7F]/g, '');
    setFormData({ ...formData, [e.target.name]: value });
  };

  const handleCoCurricularChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      co_curricular_activity_id: e.target.value, // Only one selection allowed
    }));
  };

  //    const downloadJsonFile = () => {
  //     const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(formData, null, 2));
  //     const downloadAnchor = document.createElement("a");
  //     downloadAnchor.href = dataStr;
  //     downloadAnchor.download = "formData.json";
  //     document.body.appendChild(downloadAnchor);
  //     downloadAnchor.click();
  //     document.body.removeChild(downloadAnchor);
  // };


  const handleSubmit = (e) => {
    // downloadJsonFile()
    e.preventDefault();
    setShowModal(true); // Open modal to preview data
  };


  // const handleFinalSubmit = async () => {
  //     try {
  //         const formDataObj = new FormData1();
  //         Object.keys(formData).forEach((key) => formDataObj.append(key, formData[key]));

  //         const response = await axios.post("http://127.0.0.1:8000/api/admission", formDataObj, {
  //             headers: { Authorization: `Bearer ${localStorage.getItem("parentToken")}` },
  //         });

  //         alert(response.data.message); // Show success message
  //         navigate("/parent-info");
  //         setShowModal(false); // Close modal
  //     } catch (error) {
  //         console.error("Error submitting form:", error);
  //     }
  // };
  const handleNestedChange = (e) => {
    const { name, value } = e.target;
    const sanitizedValue = value.replace(/[^\x00-\x7F]/g, '');

    setFormData((prev) => ({
      ...prev,
      lastAnnualExamMarks: {
        ...prev.lastAnnualExamMarks, // Keep existing nested data
        [name]: sanitizedValue,  // Update the specific nested field
      },
    }));
  };


  const handleFileChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.files[0] });
  };

  const handleMarksChange = (e) => {
    const { name, value } = e.target;
    const sanitizedValue = value.replace(/[^\x00-\x7F]/g, '');
    setFormData((prev) => ({
      ...prev,
      lastAnnualExamMarks: {
        ...prev.lastAnnualExamMarks,
        [name]: sanitizedValue, // Updates only marks
      },
    }));
  };


  const handleLanguageChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      lastAnnualExamMarks: {
        ...prev.lastAnnualExamMarks,
        language_id: e.target.value, // Updates only the Language field
      },
    }));
  };

  const handleHobbyChange = (e) => {
    const { value, checked } = e.target;
    const activityId = Number(value); // Convert value to number (if it's stored as a number in extraCurricular)

    setFormData((prev) => ({
      ...prev,
      extra_curricular_activity_id: checked
        ? [...prev.extra_curricular_activity_id, activityId] // Store only ID
        : prev.extra_curricular_activity_id.filter((id) => id !== activityId), // Remove ID if unchecked
    }));
  };




  // const handleFinalSubmit = async () => {
  //   navigate("/file-uploads");
  //   setFormData({
  //     medium_id: '',
  //     prevSchoolName: '',
  //     prevSchoolAddress: '',
  //     prevSchoolPincode: '',
  //     board_id: '',
  //     lastAnnualExamMarks:{
  //         marksofClass:'',
  //         English: '',
  //         Kannada: '',
  //         language_id: '',
  //         LanguageMarks: '',
  //         Maths: '',
  //         Science: '',
  //         Social: '',
  //         Total: '',
  //         PercentageCGPA: '',
  //     },
  //         candidateAdhaarNo: '',
  //         candidateSATSNo: '',
  //         class_id: '',
  //         siblingsinSSV: '',
  //         SiblingsData: '',
  //         beenToSSBV: '',
  //         co_curricular_activity_id: '',
  //         candidateAim:'',
  //        extra_curricular_activity_id: [],
  //        achivements: '',
  //   })
  // //   try {
  // //     const mobile = 1234567899;
  // //     const response = await axios.post("http://127.0.0.1:8000/api/send-otp", { mobile });
  // //     // setOtpSent(true);
  // //     // setError("");
  // //     console.log(response.data.otp);
  // //     console.log(response);


  // // }catch (error) {
  // //         console.error("Error submitting form:", error);
  // //     }
  // };

  const handleFinalSubmit = async () => {
    const token = localStorage.getItem("parentToken");
    if (!token) {
      console.error("Authentication token is missing.");
      return;
    }

    setLoading(true); // Show "Saving..."

    const requestData = {
      student_id: Number(id),
      medium_id: Number(formData.medium_id),
      prev_school_name: formData.prevSchoolName || "",
      prev_school_address: formData.prevSchoolAddress || "",
      prev_school_pincode: formData.prevSchoolPincode || "",
      board_id: Number(formData.board_id),
      last_annual_exam_marks: {
        marksofClass: formData.lastAnnualExamMarks.marksofClass || "",
        English: formData.lastAnnualExamMarks.English || "",
        Kannada: formData.lastAnnualExamMarks.Kannada || "",
        language_id: Number(formData.lastAnnualExamMarks.language_id),
        LanguageMarks: formData.lastAnnualExamMarks.LanguageMarks || "",
        Maths: formData.lastAnnualExamMarks.Maths || "",
        Science: formData.lastAnnualExamMarks.Science || "",
        Social: formData.lastAnnualExamMarks.Social || "",
        Total: formData.lastAnnualExamMarks.Total || "",
        PercentageCGPA: formData.lastAnnualExamMarks.PercentageCGPA || ""
      },
      candidate_adhaar_no: formData.candidateAdhaarNo || "",
      candidate_sats_no: formData.candidateSATSNo || "",
      candidate_pen_no: formData.candidatePENNo || "",
      class_id: Number(formData.class_id),
      siblings_in_ssv: formData.siblingsinSSV || "no",
      Siblings_data: formData.SiblingsData || "",
      been_to_sbv: formData.beenToSSBV || "no",
      co_curricular_activity_id: Number(formData.co_curricular_activity_id),
      candidate_aim: formData.candidateAim || "",
      extra_curricular_activity_id: Array.isArray(formData.extra_curricular_activity_id)
        ? formData.extra_curricular_activity_id.map(Number)
        : [],
      achivements: formData.achivements || ""
    };


    // console.log(requestData);

    try {
      const response = await fetch(API_ENDPOINTS.ACADEMIC_INFO, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(requestData),
      });

      const result = await response.json();

      if (!response.ok || !result.success) {
        let errorMessage = result.message || "An error occurred.";
        if (result.data) {
          errorMessage += "\n" + Object.values(result.data).flat().join("\n");
        }
        alert(errorMessage);
      } else {
        // console.log("Success:", result);
        navigate(`/file-uploads/${result.data.academicInfo.id}`);
        setShowModal(false); // Close modal on success
        setFormData({
          medium_id: '',
          prevSchoolName: '',
          prevSchoolAddress: '',
          prevSchoolPincode: '',
          board_id: '',
          lastAnnualExamMarks: {
            marksofClass: '',
            English: '',
            Kannada: '',
            language_id: '',
            LanguageMarks: '',
            Maths: '',
            Science: '',
            Social: '',
            Total: '',
            PercentageCGPA: '',
          },
          candidateAdhaarNo: '',
          candidateSATSNo: '',
          class_id: '',
          siblingsinSSV: '',
          SiblingsData: '',
          beenToSSBV: '',
          co_curricular_activity_id: '',
          candidateAim: '',
          extra_curricular_activity_id: [],
          achivements: '',
        });
      }
    } catch (error) {
      console.error("Network Error:", error);
      alert("Network error. Please try again.");
    } finally {
      setLoading(false); // Stop loading
    }
  };

  const isCBSE = board.find(cls => cls.id === Number(formData.board_id))?.board_name?.toUpperCase().includes('CBSE');

  return (
    <>
      {/* Preview Modal */}
      <Modal loading={loading} show={showModal} onClose={() => setShowModal(false)} formData={updatedPreviewData} onFinalSubmit={handleFinalSubmit} />


      <div className="w-full min-h-screen flex items-center justify-center bg-gray-50 px-4">
        <div className="w-full max-w-2xl bg-white rounded-lg shadow-md p-6">
          <h2 className="text-xl font-semibold text-center mb-4">Academic Information</h2>
          <form onSubmit={handleSubmit} className="grid grid-cols-1 sm:grid-cols-2 gap-4">


            {/* medium_id */}
            <div className='sm:col-span-2'>
              <label className="block text-sm font-medium text-gray-600">Medium of Instruction in the Class Studied</label>
              <select
                name="medium_id"
                required
                value={formData.medium_id}
                onChange={handleChange}
                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Select Medium</option>
                {mediums.map(cls => (
                  <option key={cls.id} value={cls.id}>{cls.media}</option>
                ))}

              </select>
            </div>

            {/* Name of the School last studied */}
            <div className='sm:col-span-2'>
              <label className="block text-sm font-medium text-gray-600">Name of the School last studied</label>
              <input
                type="text"
                name="prevSchoolName"
                placeholder=""
                value={formData.prevSchoolName}
                onChange={handleChange}
                required
                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {/* Address of the School last studied */}
            <div className=''>
              <label className="block text-sm font-medium text-gray-600">Address of the School last studied</label>
              <input
                type="text"
                name="prevSchoolAddress"
                placeholder=""
                value={formData.prevSchoolAddress}
                onChange={handleChange}
                required
                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {/* prev school zipcode */}
            <div>
              <label className="block text-sm font-medium text-gray-600">Pincode</label>
              <input
                type="number"
                name="prevSchoolPincode"
                placeholder=""
                value={formData.prevSchoolPincode}
                onChange={handleChange}
                required
                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {/* type of board */}
            <div className='sm:col-span-2'>
              <label className="block text-sm font-medium text-gray-600">Board to which the School is affiliated : (CBSE/ICSE/Other State Boards)</label>
              <select
                name="board_id"
                value={formData.board_id}
                onChange={handleChange}
                required
                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              ><option value="">Select Board</option>
                {board.map(cls => (
                  <option key={cls.id} value={cls.id}>{cls.board_name}</option>
                ))}


              </select>
            </div>

            {/*last annual exam results */}
            <div className='sm:col-span-2'>
              <label className="block text-sm font-medium text-gray-600">Fill in the Results of the Candidate in the last Annual Examinations:</label>

              {/* last annual mark class */}
              <div className='sm:col-span-2'>
                <select
                  name="marksofClass"
                  required
                  value={formData.lastAnnualExamMarks.marksofClass}
                  onChange={handleNestedChange}
                  className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">Select Class</option>
                  {/* <option value="IV">IV</option> */}
                  <option value="V">V</option>
                  <option value="VI">VI</option>
                  <option value="VII">VII</option>
                  {/* <option value="VIII">VIII</option> */}

                </select>
              </div>

              <table className="w-full border-collapse border border-gray-300 mt-4">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border p-2">Subject</th>
                    <th className="border p-2">Marks/Grades</th>
                  </tr>
                </thead>
                <tbody>
                  {/* English */}
                  <tr>
                    <td className="border p-2">English</td>
                    <td className="border p-2">
                      <input
                        required
                        type="text"
                        name="English"
                        value={formData.lastAnnualExamMarks.English}
                        onChange={handleMarksChange}
                        className="w-full p-2 focus:outline-none"
                      />
                    </td>
                  </tr>

                  {/* Kannada */}
                  <tr>
                    <td className="border p-2">Kannada</td>
                    <td className="border p-2">
                      <input
                        required
                        type="text"
                        name="Kannada"
                        value={formData.lastAnnualExamMarks.Kannada}
                        onChange={handleMarksChange}
                        className="w-full p-2 focus:outline-none"
                      />
                    </td>
                  </tr>

                  {/* Language Marks */}
                  <tr>
                    <td className="border p-2">
                      <select
                        value={formData.lastAnnualExamMarks.language_id}
                        onChange={handleLanguageChange}
                        className="w-full p-2 pl-0 rounded-lg"
                        required
                      >
                        <option value="">Select Language</option>
                        {language.map(cls => (
                          <option key={cls.id} value={cls.id}>{cls.language}</option>
                        ))}
                      </select>
                    </td>
                    <td className="border p-2">
                      <input
                        required
                        type="text"
                        name="LanguageMarks"
                        value={formData.lastAnnualExamMarks.LanguageMarks}
                        onChange={handleMarksChange}
                        className="w-full p-2 focus:outline-none"
                      />
                    </td>
                  </tr>

                  {/* Maths */}
                  <tr>
                    <td className="border p-2">Maths</td>
                    <td className="border p-2">
                      <input
                        required
                        type="text"
                        name="Maths"
                        value={formData.lastAnnualExamMarks.Maths}
                        onChange={handleMarksChange}
                        className="w-full p-2 focus:outline-none"
                      />
                    </td>
                  </tr>

                  {/* Science */}
                  <tr>
                    <td className="border p-2">Science</td>
                    <td className="border p-2">
                      <input
                        required
                        type="text"
                        name="Science"
                        value={formData.lastAnnualExamMarks.Science}
                        onChange={handleMarksChange}
                        className="w-full p-2 focus:outline-none"
                      />
                    </td>
                  </tr>

                  {/* Social */}
                  <tr>
                    <td className="border p-2">Social</td>
                    <td className="border p-2">
                      <input
                        required
                        type="text"
                        name="Social"
                        value={formData.lastAnnualExamMarks.Social}
                        onChange={handleMarksChange}
                        className="w-full p-2 focus:outline-none"
                      />
                    </td>
                  </tr>

                  {/* Total */}
                  <tr>
                    <td className="border p-2">Total</td>
                    <td className="border p-2">
                      <input
                        required
                        type="text"
                        name="Total"
                        value={formData.lastAnnualExamMarks.Total}
                        onChange={handleMarksChange}
                        className="w-full p-2 focus:outline-none"
                      />
                    </td>
                  </tr>

                  {/* Percentage/CGPA */}
                  <tr>
                    <td className="border p-2 font-bold">Percentage/CGPA</td>
                    <td className="border p-2">
                      <input
                        required
                        type="text"
                        name="PercentageCGPA"
                        value={formData.lastAnnualExamMarks.PercentageCGPA}
                        onChange={handleMarksChange}
                        className="w-full p-2 focus:outline-none"
                      />
                    </td>
                  </tr>

                </tbody>
              </table>
            </div>

            {/* {
  console.log(extraCurricular)
} */}
            {/* Extra-Curricular Activities */}
            <div className='sm:col-span-2'>
              <label className="block text-sm font-medium text-gray-600 mb-1">
                Extra-Curricular Activities You Have Participated In
              </label>
              <div className="grid grid-cols-2 gap-2">
                {extraCurricular.map((activity) => (
                  <label key={activity.id} className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      name="extra_curricular_activity_id"
                      value={activity.id} // Use ID as the value
                      checked={formData.extra_curricular_activity_id.includes(activity.id)} // Check if ID exists in the array
                      onChange={handleHobbyChange}
                      className="rounded"
                    />
                    <span>{activity.activity_name}</span>
                  </label>
                ))}
              </div>
            </div>






            {/* Achievements and the Awards or Honors received, if any */}
            <div className='sm:col-span-2'>
              <label className="block text-sm font-medium text-gray-600">Achievements and the Awards or Honors received, if any</label>
              <input
                type="text"
                name="achivements"
                placeholder=""
                value={formData.achivements}
                onChange={handleChange}
                required
                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>


            {/* Candidate Adhaar Number */}
            <div>
              <label className="block text-sm font-medium text-gray-600">Candidate's Adhaar Number</label>
              <input
                type="number"
                name="candidateAdhaarNo"
                placeholder=""
                value={formData.candidateAdhaarNo}
                onChange={handleChange}
                required
                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                title="Enter a valid 12-digit Aadhaar number"
                pattern="\d{12}"
              />
            </div>

            {/* Candidate SATS* Number */}
            <div>
              <label className="block text-sm font-medium text-gray-600">Candidate's SATS* Number
                <a href=''>check SATS No.</a>
              </label>
              <input
                type="number"
                name="candidateSATSNo"
                placeholder=""
                value={formData.candidateSATSNo}
                onChange={handleChange}
                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"

              />
            </div>

            {/* Candidate PEN* Number */}
            <div>
              <label className="block text-sm font-medium text-gray-600">Personal Education Number (PEN)*</label>
              <input
                type="number"
                name="candidatePENNo"
                placeholder=""
                value={formData.candidatePENNo}
                onChange={handleChange}
                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>



            {/*  Class Id */}
            <div>
              <label className="block text-sm font-medium text-gray-600">Class for which Admission is Sought</label>
              <select
                name="class_id"
                value={formData.class_id}
                onChange={handleChange}
                required
                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Select Class</option>
                {classes.map(cls => (
                  <option key={cls.id} value={cls.id}>{cls.name}</option>
                ))}
              </select>
            </div>

            {/*are there siblings in ssv */}
            <div className='sm:col-span-2'>
              <label className="block text-sm font-medium text-gray-600">Are there any of your brother/s or sister/s who have studied or studying in Bhagwan Shri Sathya Sai Vidyakendra Chokkady?</label>
              <input
                type="radio"
                name="siblingsinSSV"
                value="yes"
                checked={formData.siblingsinSSV === "yes"}
                onChange={handleChange}
                required
              /> Yes

              &nbsp;
              <input
                type="radio"
                name="siblingsinSSV"
                value="no"
                checked={formData.siblingsinSSV === "no"}
                onChange={handleChange}
                required
              /> No

            </div>


            {/* siblings details */}
            <div className={`sm:col-span-2 ${formData.siblingsinSSV === "yes" ? "" : "hidden"}`}>
              <label className="block text-sm font-medium text-gray-600"> Give below particulars about your brother(s)/sister(s) who have studied/studying in Bhagawan Shri
                Sathya Sai Vidya Kendra, Chokkady.</label>
              <p className='text-xs text-gray-800'>Mention their Name, Relation , Course/std, Academic Year
                From/To</p>
              <textarea
                type="text"
                name="SiblingsData"
                placeholder=""
                value={formData.SiblingsData}
                onChange={handleChange}
                required={formData.siblingsinSSV === "yes"}
                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>



            {/*Have you ever been a student of Sathya Sai Bal Vikas? */}
            <div className='sm:col-span-2'>
              <label className="block text-sm font-medium text-gray-600">Have you ever been a student of Sathya Sai Bal Vikas?</label>
              <input
                type="radio"
                name="beenToSSBV"
                value="yes"
                checked={formData.beenToSSBV === "yes"}
                onChange={handleChange}
                required
              /> Yes

              &nbsp;
              <input
                type="radio"
                name="beenToSSBV"
                value="no"
                checked={formData.beenToSSBV === "no"}
                onChange={handleChange}
                required
              /> No

            </div>



            {/* Co-Curricular Activity Wish to Join */}
            <div className='sm:col-span-2'>
              <label className="block text-sm font-medium text-gray-600 mb-1">
                Select any One Co-Curricular Activity the Student Wishes to Join
              </label>
              <select
                name="co_curricular_activity_id"
                value={formData.co_curricular_activity_id}
                onChange={handleCoCurricularChange}
                required
                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Select an Activity</option>
                {co_curricular_activities.map(cls => (
                  <option key={cls.id} value={cls.id}>{cls.activity_name}</option>
                ))}
              </select>
            </div>




            {/* Aim and Objective which the candidate may have set for her/himself in life */}
            <div className='sm:col-span-2'>
              <label className="block text-sm font-medium text-gray-600">Aim and Objective which the candidate may have set for her/himself in life</label>
              <textarea
                type="text"
                name="candidateAim"
                placeholder=""
                value={formData.candidateAim}
                onChange={handleChange}
                required
                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>




            {/* Submit Button (Full Width) */}
            <div className="sm:col-span-2">
              <button
                type="submit"
                className="w-full bg-blue-500 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg transition duration-200"
              >
                Preview
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AcademicInfo;
